import React, { useContext } from 'react';
import { Route, Routes, ScrollToTop } from '@thd-olt-component-react/router';
import { string } from 'prop-types';
import { AppContext } from '@thd-nucleus/app-render';
import { Error } from './pages';
import { getRoutes } from './routes';
import './styles/app.scss';

export const App = ({ pipTimeout, serverPages }) => {
  const { instance } = useContext(AppContext);

  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;

  const routes = getRoutes(currentRouteName, currentRouteComponent, serverPages);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          exact
          path={routes.product.path}
          element={<routes.product.component pipTimeout={pipTimeout} />}
        />
        <Route element={<Error />} />
      </Routes>
    </>
  );
};

App.propTypes = {
  pipTimeout: string
};

App.defaultProps = {
  pipTimeout: null
};
